import { CSV_TARGETS, type ParsedCsv } from "../../lib/csv";

const targets = CSV_TARGETS.filter(
  (target) => target.key !== "lat" && target.key !== "lon",
);

/* The preview's column picks. A change here is what the upload saves. */
export function PointColumnMap({
  parsed,
  mapping,
  onChange,
}: {
  parsed: ParsedCsv;
  mapping: Record<string, number | null>;
  onChange: (mapping: Record<string, number | null>) => void;
}) {
  return (
    <div className="max-h-40 space-y-1 overflow-auto rounded border border-line p-2">
      <p className="text-[11px] text-muted">
        Column matching — change a column if the preview picked the wrong one.
      </p>
      {targets.map((target) => (
        <label
          key={target.key}
          className="flex items-center justify-between gap-2 text-[10px]"
        >
          <span className="text-muted">{target.label}</span>
          <select
            aria-label={`Column for ${target.label}`}
            value={mapping[target.key] ?? -1}
            onChange={(event) => {
              const value = Number(event.target.value);
              onChange({
                ...mapping,
                [target.key]: value === -1 ? null : value,
              });
            }}
            className="w-36 rounded border border-line bg-surface px-1 py-0.5 text-[10px]"
          >
            <option value={-1}>— skip —</option>
            {parsed.headers.map((header, index) => (
              <option key={index} value={index}>
                {header || `(column ${index + 1})`}
              </option>
            ))}
          </select>
        </label>
      ))}
    </div>
  );
}
